import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  LinearProgress,
  Typography,
  useTheme,
} from "@mui/material";

import EventIcon from "@mui/icons-material/Event";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { styled } from "@mui/system";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import {
  getClinicianProfile,
  updateClinicianSession,
  updateSession,
} from "../../../../api/services/api";
import { icons } from "../../../../assets";
import Loader from "../../../../components/Loader";
import { GoogleMeetCard } from "../../../../components/GoogleMeet";

interface SessionProps {
  patientView?: Boolean;
  sessionId: string;
  speciality: string;
  modeOfConsultation: string;
  bookedDate: any;
  sessionDate: any;
  sessionMonth: any;
  startTime: any;
  endTime: any;
  timeSlots?: any;
  description: string;
  doctorImage: string;
  doctorName: string;
  doctorSpeciality: string;
  doctorExperience: string;
  patientImage: string;
  patientName: string;
  patientNumber: number;
  patientEmail: string;
  patientProfileImage: string;
  PatientProfileName: string;
  PatientProfileAge: number;
  PatientProfileGender: string;
  PatientLandmark: string;
  patientAddress1: string;
  patientAddress2: string;
  PatientCity: string;
  consultationFee: number;
  doctorFee: number;
  statusData: any;
  startSessionClick: any;
  handleReportClick: any;
  handleComplete: any;
  handlePdfChange?: any;
  generateReportClick?: any;
  handleReportsView?: any;
  joinHomeSession?: any;
  minutes?: any;
  seconds?: any;
  progress?: any;
  handleOtpClick?: any;
  otpChange?: any;
  otpValue?: any;
  otpDate?: any;
  checkOtp?: any;
  onRefreshSession?: () => void; // Add refresh callback
}

export const SessionDetailCard = ({
  patientView,
  sessionId,
  speciality,
  modeOfConsultation,
  bookedDate,
  sessionDate,
  sessionMonth,
  startTime,
  endTime,
  timeSlots,
  description,
  patientImage,
  patientName,
  patientNumber,
  patientEmail,
  patientProfileImage,
  PatientProfileName,
  PatientProfileAge,
  PatientProfileGender,
  PatientLandmark,
  patientAddress1,
  patientAddress2,
  PatientCity,
  consultationFee,
  doctorFee,
  doctorImage,
  doctorName,
  doctorSpeciality,
  doctorExperience,
  statusData,
  startSessionClick,
  handleReportClick,
  handleComplete,
  handlePdfChange,
  generateReportClick,
  handleReportsView,
  joinHomeSession,
  minutes,
  seconds,
  progress,
  handleOtpClick,
  otpChange,
  otpValue,
  otpDate,
  checkOtp,
  onRefreshSession,
}: SessionProps) => {
  const theme = useTheme();
  const id = useParams();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(updateSession, {
    onSuccess: () => {
      queryClient.invalidateQueries("sessions");
    },
  });

  const handleReject = () => {
    const res = { status: "REJECTED" };
    mutate({ id: id?.id, body: res });
  };


  const { data } = useQuery("clinician-profile", getClinicianProfile);

  const { mutate: clinicianMutate } = useMutation(updateClinicianSession, {
    onSuccess: () => {
      queryClient.invalidateQueries("sessions");
    },
  });

  const NewClincianAccept = () => {
    const res = { isNewClinicianAccepted: true };
    clinicianMutate({ id: statusData?.data?.sessionClinician?.id, body: res });
  };

  const NewClinicianReject = () => {
    const res = { isNewClinicianAccepted: false };
    clinicianMutate({ id: statusData?.data?.sessionClinician?.id, body: res });
  };

  if (isLoading) {
    <Loader />;
  }

  console.log(consultationFee, "fees");

  return (
    <Box p={2} overflow="auto" maxHeight="700px" className="scrollBox">
      <Box p={2} border={"1px solid rgba(34, 34, 34, 0.08)"} borderRadius="5px">
        <Typography variant="h4">{sessionId}</Typography>
        <Grid container spacing={1.5} mt={0.5}>
          <Grid item xs={6}>
            <TitleName title="Speciality" detail={speciality} />
          </Grid>
          <Grid item xs={6}>
            <TitleName
              title="Mode of consultation"
              detail={modeOfConsultation}
            />
          </Grid>
          <Grid item xs={6}>
            <TitleName title="Booked date" detail={bookedDate} />
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" gap={1} pt={1}>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent={"center"}
                p={1}
                maxWidth="30px"
                alignItems="center"
                sx={{ backgroundColor: "#F0F0F0", borderRadius: "10px" }}
              >
                <Typography>{sessionDate}</Typography>
                <Typography>{sessionMonth}</Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Typography variant="caption" sx={{ fontSize: "12px" }}>
                  Time Slot
                </Typography>
                {timeSlots?.map((item: any, index: number) => (
                  <Typography key={index}>
                    {item?.timeslot?.startAt}-{item?.timeslot?.endAt}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Box>
          <TitleName title="Description" detail={description} />
        </Box>
      </Box>
      {/* <Box
        mt={2}
        pt={2}
        border={"1px solid rgba(34, 34, 34, 0.08)"}
        borderRadius="5px"
      >
        <Typography pb={2} px={2} variant="h4">
          Clinician's Details
        </Typography>
        <Divider />
        <Box display="flex" alignItems="center" p={2}>
          <Avatar
            variant="rounded"
            sx={{ height: "80px", width: "80px", fontSize: "40px" }}
            src={doctorImage}
            alt={doctorName}
          />
          <Box pl={2}>
            <Typography variant="h5">{doctorName}</Typography>
            <Typography variant="subtitle2" sx={{ color: "#1268AE" }}>
              {doctorSpeciality}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#ECF3F9",
                px: "15px",
                py: "4px",
                mt: "5px",
                borderRadius: "11px",
              }}
            >
              <Typography variant="subtitle2">
                {doctorExperience} Year Exp.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box> */}
      {/* <Box
        mt={2}
        pt={2}
        border={"1px solid rgba(34, 34, 34, 0.08)"}
        borderRadius="5px"
      >
        <Typography pb={2} px={2} variant="h4">
          Client Details
        </Typography>
        <Divider />
        <Box display="flex" alignItems="center" p={2}>
          <Avatar
            variant="rounded"
            sx={{ height: "80px", width: "80px", fontSize: "40px" }}
            src={patientImage}
            alt={patientName}
          />
          <Box pl={2}>
            <Typography variant="h5">{patientName}</Typography>
            <Box display="flex" gap={1} alignItems="center">
              <img
                src={icons.mobileIcn}
                style={{ width: "20px", height: "20px" }}
              />
              <Typography>{patientNumber}</Typography>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              <img
                src={icons.emailIcn}
                style={{ width: "20px", height: "15px" }}
              />
              <Typography>{patientEmail}</Typography>
            </Box>
          </Box>
        </Box>
      </Box> */}
      <Box
        mt={2}
        pt={2}
        border={"1px solid rgba(34, 34, 34, 0.08)"}
        borderRadius="5px"
      >
        <Typography pb={2} px={2} variant="h4">
          Client Details
        </Typography>
        <Divider />
        <Box
          display="flex"
          p={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" alignItems="center">
            <Avatar
              variant="rounded"
              sx={{ height: "80px", width: "80px", fontSize: "40px" }}
              src={patientProfileImage}
              alt={PatientProfileName}
            />
            <Box pl={2}>
              <Typography variant="h5">{PatientProfileName}</Typography>
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                {PatientProfileAge} years
              </Typography>
              <Typography variant="subtitle2">
                {PatientProfileGender}
              </Typography>
            </Box>
          </Box>
          <Box paddingRight={60}>
            <Button variant="outlined" onClick={handleReportClick}>
              Medical Records
            </Button>
          </Box>
        </Box>
      </Box>
      {statusData?.data?.consultationMode === "HOME" && (
        <Box
          mt={2}
          py={2}
          border={"1px solid rgba(34, 34, 34, 0.08)"}
          borderRadius="5px"
        >
          <Typography pb={2} px={2} variant="h4">
            Patient Location Details
          </Typography>
          <Divider />

          <Box display="flex" p={2} gap={1}>
            <PlaceOutlinedIcon />
            <Box>
              <Typography>{PatientCity}</Typography>
              <Typography>
                {patientAddress1}, {patientAddress2}, {PatientLandmark}{" "}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" px={2.4} gap={1.4} alignItems="center">
            <img src={icons.mobileIcn} alt="Mobile Icon" />
            <Typography>{patientNumber}</Typography>
          </Box>
        </Box>
      )}
      <Box
        mt={2}
        pt={2}
        border={"1px solid rgba(34, 34, 34, 0.08)"}
        borderRadius="5px"
      >
        <Typography pb={2} px={2} variant="h4">
          Consultation Bill Details
        </Typography>
        <Divider />

        <Box display="flex" p={2} gap={1} justifyContent="space-between">
          <Typography>Doctor Fee</Typography>
          <Typography paddingRight={70}>{doctorFee} SAR</Typography>
        </Box>
        <Box display="flex" p={2} gap={1} justifyContent="space-between">
          <Typography>Consultation Fee</Typography>
          <Typography paddingRight={70}>{consultationFee} SAR</Typography>
        </Box>
        <Divider />
        <Box display="flex" p={2} gap={1} justifyContent="space-between">
          <Typography>Total Amount</Typography>
          <Typography paddingRight={70}>
            {Number(consultationFee) + Number(doctorFee)} SAR
          </Typography>
        </Box>
      </Box>

      {(statusData?.data?.consultationMode === "VIDEO" ||
        statusData?.data?.consultationMode === "video") &&
        (statusData?.data?.meetingLink ||
          statusData?.data?.googleMeetLink ||
          statusData?.data?.hangoutLink) && (
          <Box sx={{ mt: 2 }}>
            <GoogleMeetCard
              session={{
                ...statusData?.data,
                meetingLink: statusData?.data?.meetingLink || statusData?.data?.googleMeetLink || statusData?.data?.hangoutLink
              }}
              onJoinMeeting={() => {
                console.log('Clinician joined Google Meet');
              }}
            />
          </Box>
        )}

      {(statusData?.data?.consultationMode === "VIDEO" ||
        statusData?.data?.consultationMode === "video") &&
        !(statusData?.data?.meetingLink ||
          statusData?.data?.googleMeetLink ||
          statusData?.data?.hangoutLink) && (
          <Box sx={{
            mt: 2,
            p: 2,
            backgroundColor: theme.colors.warning.lighter,
            borderRadius: 1,
            border: `1px solid ${theme.colors.warning.light}`
          }}>
            <Typography variant="h6" sx={{ mb: 1, color: theme.colors.warning.dark }}>
              Google Meet Link Not Available
            </Typography>
            <Typography variant="body2" sx={{ color: theme.colors.warning.dark }}>
              This is a video session but the Google Meet link is not yet available.
              The link should be created when the patient completes payment.
            </Typography>
          </Box>
        )}

      {Boolean(joinHomeSession) && (
        <Box>
          {checkOtp === false && (
            <Box>
              <MuiOtpInput
                mx={10}
                mt={3}
                value={otpValue}
                onChange={otpChange}
                TextFieldsProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
              />
              <Button
                sx={{ mt: 3 }}
                fullWidth
                onClick={handleOtpClick}
                variant="contained"
                type="submit"
              >
                Submit OTP
              </Button>
            </Box>
          )}
          {Boolean(checkOtp) && (
            <Box mt={2} bgcolor="#F0F0F0" borderRadius="10px" px={2} py={2}>
              <FlexBox>
                <FlexBox alignItems="center" gap={1}>
                  <EventIcon />
                  <Typography>{otpDate}</Typography>
                </FlexBox>
              </FlexBox>
              <FlexBox alignItems="center" justifyContent="space-between">
                <Typography variant="h4" sx={{ mb: 2, mt: 3 }}>
                  Session's Remaining Time is
                </Typography>
                <Box color="#2E78E6" maxWidth="95px" pr={4} display="flex">
                  <Typography>{minutes}</Typography>
                  <Typography>:</Typography>
                  <Typography>{seconds}</Typography>
                </Box>
              </FlexBox>
              <Box my={1}>
                <LinearProgress
                  sx={{ height: "8px", borderRadius: "10px", color: "#2E78E6" }}
                  variant="determinate"
                  value={progress}
                />
              </Box>
            </Box>
          )}
        </Box>
      )}

      {statusData?.data?.status === "PENDING" && (
        <>
          {patientView === false && (
            <Box pt={2} display="flex" gap={2}>
              <Button
                onClick={() => handleReject()}
                // fullWidth
                variant="contained"
                sx={{
                  width: "300px",
                  marginLeft: "400px",
                  color: theme.colors.error.main,
                  backgroundColor: theme.colors.error.lighter,
                  "&:hover": {
                    background: theme.colors.error.main,
                    color: "white",
                  },
                }}
              >
                Reject
              </Button>
            </Box>
          )}
        </>
      )}

      {statusData?.data?.status === "COMPLETED" ? (
        <>
          {patientView === false && (
            <>
              <Box width={700} paddingLeft={60}>
                <Button
                  onClick={generateReportClick}
                  sx={{ mt: 2, width: "300px" }}
                  variant="contained"
                // fullWidth
                >
                  Generate Report
                </Button>
              </Box>
            </>
          )}
        </>
      ) : null}

      {statusData?.data?.status === "REPORT_SUBMITTED" && (
        <Box mt={2}>
          {patientView === false && (
            <Button
              onClick={handleReportsView}
              variant="outlined"
              sx={{ width: "300px", marginLeft: "550px" }}
            >
              View Reports
            </Button>
          )}
        </Box>
      )}

      {statusData?.data?.status === "STARTED" && (
        <>
          {patientView === false && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={handleComplete}
                sx={{ mt: 2 }}
                variant="contained"
              >
                Complete Session
              </Button>
            </Box>
          )}
        </>
      )}

      {/* {statusData?.data?.status === "PAID" && (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={startSessionClick}
              sx={{ mt: 2 }}
              variant="contained"
            >
              Start Session
            </Button>
          </Box>
        </>
      )} */}


    </Box>
  );
};

let FlexBox = styled(Box)({
  display: "flex",
  alignItems: "center",
});

const TitleName = ({ title, detail }: any) => {
  // Try to parse and format description if it's JSON
  const renderDescription = () => {
    if (!detail || detail === "N/A") return <Typography>{detail}</Typography>;

    try {
      const parsed = JSON.parse(detail);

      return (
        <Box>
          {parsed.originalDescription && (
            <Typography sx={{ mb: 1, fontWeight: 500 }}>
              {parsed.originalDescription}
            </Typography>
          )}

          {parsed.timeslotsByDate && parsed.timeslotsByDate.length > 0 && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" sx={{ fontWeight: 600, display: "block", mb: 0.5 }}>
                Scheduled Dates:
              </Typography>
              {parsed.timeslotsByDate.map((slot: any, idx: number) => (
                <Typography key={idx} variant="body2" sx={{ color: "text.secondary", fontSize: "13px" }}>
                  • {slot.date} (Timeslot IDs: {slot.timeslotIds.join(", ")})
                </Typography>
              ))}
            </Box>
          )}

          {parsed.timeslotIds && parsed.timeslotIds.length > 0 && !parsed.timeslotsByDate && (
            <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
              Timeslot IDs: {parsed.timeslotIds.join(", ")}
            </Typography>
          )}
        </Box>
      );
    } catch {
      return <Typography>{detail}</Typography>;
    }
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <Typography variant="caption" sx={{ fontSize: "12px" }}>
        {title}
      </Typography>
      {renderDescription()}
    </Box>
  );
};
